var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"患者年龄段统计"}},[_c('age')],1),_c('TabPane',{attrs:{"label":"患者性别统计"}},[_c('sex')],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4534b9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/patientStatistics/index.vue
// module id = null
// module chunks = 